var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCampaign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 78,
    viewBox: "0 0 77 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_478_2293)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 69,
    height: 70,
    rx: 34.5,
    fill: "#223F9E",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_478_2293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.375 26.5003H37.031C36.857 26.5015 36.685 26.4616 36.5281 26.3837L32.9776 24.5357C32.5089 24.2936 31.9926 24.1674 31.469 24.167H28.625C27.1337 24.1688 25.704 24.784 24.6495 25.8776C23.595 26.9711 23.0018 28.4538 23 30.0003V44.0003C23.0018 45.5469 23.595 47.0295 24.6495 48.1231C25.704 49.2166 27.1337 49.8318 28.625 49.8337H44.375C45.8663 49.8318 47.296 49.2166 48.3505 48.1231C49.405 47.0295 49.9982 45.5469 50 44.0003V32.3337C49.9982 30.7871 49.405 29.3045 48.3505 28.2109C47.296 27.1174 45.8663 26.5022 44.375 26.5003ZM28.625 26.5003H31.469C31.643 26.4991 31.815 26.539 31.9719 26.617L35.5224 28.4592C35.9906 28.7032 36.507 28.8314 37.031 28.8337H44.375C45.0478 28.8348 45.7049 29.0444 46.262 29.4357C46.819 29.8269 47.2506 30.3819 47.5014 31.0293L25.25 31.16V30.0003C25.25 29.0721 25.6056 28.1818 26.2385 27.5255C26.8714 26.8691 27.7299 26.5003 28.625 26.5003ZM44.375 47.5003H28.625C27.7299 47.5003 26.8714 47.1316 26.2385 46.4752C25.6056 45.8188 25.25 44.9286 25.25 44.0003V33.4933L47.75 33.3615V44.0003C47.75 44.9286 47.3944 45.8188 46.7615 46.4752C46.1286 47.1316 45.2701 47.5003 44.375 47.5003Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_478_2293",
    x: 0,
    y: 0,
    width: 77,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.515609 0 0 0 0 0.515609 0 0 0 0 0.515609 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_478_2293"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_478_2293",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_478_2293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 28,
    fill: "white",
    transform: "translate(23 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCampaign);
export default __webpack_public_path__ + "static/media/icon_campaign.4e05df23b0e51b6496c2c9f62e904d0a.svg";
export { ForwardRef as ReactComponent };